import {
  Dispatch,
  FC,
  SetStateAction,
} from "react";

import clsx from "clsx";

import { QuestionComponentProps } from "../../../../../../../../model";

import st from "./Sequence.module.scss";

type Props = QuestionComponentProps;

export const Sequence: FC<Props> = ({
  answers,
  userAnswer,
  setUserAnswer,
}) => {
  const userAnswerT =
    Array.isArray(userAnswer)? userAnswer as number[]: [];
  const setUserAnswerT = setUserAnswer as Dispatch<SetStateAction<number[]>>;

  const onClick = (answerIndex: number) => {
    setUserAnswerT((prev) => {
      if (!prev || !Array.isArray(prev)) return [ answerIndex ];

      return prev.includes(answerIndex)? prev.filter((i) => i !== answerIndex): [ ...prev, answerIndex ];
    });
  };

  const getSelectedIndex = (index: number) => {
    const findIndex = userAnswerT.findIndex((val) => val === index) + 1;
    return findIndex || "";
  };

  return (
    <ul>
      {
        answers.map((answer, index) => {
          const selectedIndex = getSelectedIndex(index);
          return (
            <li
              key={index}
              className={clsx(st.wrap, selectedIndex && st.checked)}
              onClick={() => onClick(index)}
            >
              {
                selectedIndex && (
                  <div className={st.index_badge}>{selectedIndex}</div>
                )
              }
              <p>{answer}</p>
            </li>
          );
        })
      }
    </ul>
  );
};
